export { default } from './Alert';

export const ALERT_TIMEOUT = 6000;
